import React, { useState, useRef, useEffect, useCallback } from 'react';
import Styles from './SelectCheck.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useOnClickOutside } from 'shared/hooks';
import PropTypes from 'prop-types';

export default function SelectCheck({
  items = [],
  selectedItems,
  open,
  renderItem,
  onChange,
  filter,
}) {
  const [innerSelectedItems, setInnerSelectedItems] = useState(
    selectedItems || [],
  );
  const [innerOpen, setInnerOpen] = useState(open || false);
  const [filterText, setFilterText] = useState('');
  const [overlayRef, setOverlayRef] = useState(undefined);
  const inputRef = useRef();
  const referenceSelectedItens =
    selectedItems === undefined ? innerSelectedItems : selectedItems;

  useEffect(() => {
    // If the overlay is defined, check if the scroll wont be overflowing the screen
    if (overlayRef && inputRef) {
      const inputPosition = inputRef.current.getBoundingClientRect();
      const pixelsToBottom = window.clientHeight - inputPosition.x;
      if (pixelsToBottom < 400) {
        // If the position is almost overflowing the bottom
        overlayRef.style.bottom = '0px'; // Make the select start from bottom to top
      }
    }
  }, [overlayRef]);

  const close = useCallback(() => {
    setInnerOpen(false);
  }, []);

  useOnClickOutside(inputRef, close);

  function toggleItem(item) {
    let selectedItems;
    if (referenceSelectedItens.indexOf(item) === -1) {
      selectedItems = [...innerSelectedItems, item];
    } else {
      selectedItems = innerSelectedItems.filter(i => i !== item);
    }
    onChange(selectedItems);
    setInnerSelectedItems(selectedItems);
  }

  useEffect(() => {
    setInnerSelectedItems(selectedItems || []);
  }, [selectedItems]);

  return (
    <>
      <button
        ref={inputRef}
        className={Styles.Input}
        onClick={() => setInnerOpen(true)}
      >
        {referenceSelectedItens.length > 0
          ? referenceSelectedItens.map((i, index) => (
            <div key={String(index)} className={Styles.SelectedOptions}>
              {renderItem(i)},&nbsp;
            </div>
            ))
          : 'Nenhuma seleção'}
        {(open === undefined ? innerOpen : open) && (
          <div ref={setOverlayRef} className={Styles.Overlay}>
            {filter && (
              <input
                className={Styles.FilterInput}
                defaultValue={filterText}
                onChange={({ target: { value } }) => setFilterText(value)}
              />
            )}
            {items
              .filter(i => filter(filterText, i))
              .map(i => (
                <div className={Styles.Item} onClick={() => toggleItem(i)}>
                  {renderItem(i)}
                  {referenceSelectedItens.indexOf(i) === -1 ? null : (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className={Styles.ItemState}
                    />
                  )}
                </div>
              ))}
          </div>
        )}
      </button>
    </>
  );
}
SelectCheck.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.any),
  open: PropTypes.bool,
  renderItem: PropTypes.func,
  filter: PropTypes.func,
};

SelectCheck.defaultProps = {
  selectedItems: undefined,
  open: undefined,
  renderItem: i => i,
  filter: () => true,
};
